module.exports = __webpack_public_path__ + "static/media/sfx_ui_switch_tab.93ccc972.mp3";